import { Page, Header, Content } from '@backstage/core-components';
import { CopilotChatInterface } from './CopilotChatInterface';

const SUGGESTED_PROMPTS = [
  "What systems does my team own?",
  "Show me all APIs in the platform",
  "How do I create a new microservice?",
  "Which components don't have TechDocs?",
  "What tools can you use from here?",
];

export const CopilotGlobalPage = () => (
  <Page themeId="tool">
    <Header title="Copilot" subtitle="Your AI platform assistant" />
    <Content>
      <CopilotChatInterface suggestedPrompts={SUGGESTED_PROMPTS} />
    </Content>
  </Page>
);
